import type { BillStatus } from '@bbpos/types';
import type { StatusKey } from '@bbpos/ui';

export const STATUS_BADGE_MAP: Record<BillStatus, StatusKey> = {
  DRAFT: 'draft',
  PARKED: 'parked',
  COMPLETED: 'completed',
  RETURNED: 'returned',
  VOID: 'voided',
  PENDING_DISCOUNT_APPROVAL: 'pendingDiscountApproval',
};

/**
 * Drafts are not invoiced: the server assigns the INV- number only when the
 * bill is completed and stores an opaque `DRAFT-…` placeholder until then.
 */
export const DRAFT_BILL_PREFIX = 'DRAFT-';

export function isDraftBillNumber(billNumber: string | null | undefined): boolean {
  return typeof billNumber === 'string' && billNumber.startsWith(DRAFT_BILL_PREFIX);
}

/**
 * What to render for a bill's number — a draft shows a label, not the placeholder.
 * A PARKED bill keeps its `DRAFT-…` placeholder until completion, but staff name
 * it by its park reference ("Bill parked as #PKD-…"), so it reads "Parked #PKD-…"
 * (GPD5, as admin's bill-number.ts).
 */
export function formatBillNumber(bill: {
  bill_number: string;
  status?: string;
  park_reference?: string | null;
}): string {
  if (bill.status === 'PARKED' && bill.park_reference) return `Parked #${bill.park_reference}`;
  return isDraftBillNumber(bill.bill_number) ? 'Draft (unnumbered)' : bill.bill_number;
}
